var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseUnlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2241_3461)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.25195H4.1875V2.75195C4.1875 2.26914 4.57969 1.87695 5.0625 1.87695H8.9375C9.42031 1.87695 9.8125 2.26914 9.8125 2.75195V3.81445C9.8125 3.8832 9.86875 3.93945 9.9375 3.93945H10.8125C10.8813 3.93945 10.9375 3.8832 10.9375 3.81445V2.75195C10.9375 1.64727 10.0422 0.751953 8.9375 0.751953H5.0625C3.95781 0.751953 3.0625 1.64727 3.0625 2.75195V6.25195H2C1.72344 6.25195 1.5 6.47539 1.5 6.75195V12.752C1.5 13.0285 1.72344 13.252 2 13.252H12C12.2766 13.252 12.5 13.0285 12.5 12.752V6.75195C12.5 6.47539 12.2766 6.25195 12 6.25195ZM11.375 12.127H2.625V7.37695H11.375V12.127ZM6.5625 9.95508V10.7832C6.5625 10.852 6.61875 10.9082 6.6875 10.9082H7.3125C7.38125 10.9082 7.4375 10.852 7.4375 10.7832V9.95508C7.56648 9.86248 7.66275 9.73134 7.71245 9.58054C7.76216 9.42974 7.76273 9.26706 7.71409 9.11591C7.66545 8.96477 7.57011 8.83295 7.44179 8.73945C7.31346 8.64594 7.15878 8.59556 7 8.59556C6.84122 8.59556 6.68654 8.64594 6.55821 8.73945C6.42989 8.83295 6.33455 8.96477 6.28591 9.11591C6.23727 9.26706 6.23784 9.42974 6.28755 9.58054C6.33725 9.73134 6.43352 9.86248 6.5625 9.95508Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2241_3461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseUnlockIcon);
export default __webpack_public_path__ + "static/media/purchase-unlock-icon.135284e9d81f6ce5f96676b0376aa057.svg";
export { ForwardRef as ReactComponent };